module.exports = __WEBPACK_EXTERNAL_MODULE_145__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes"}
// module id = 145
// module chunks = 0